<expander
  class="mr-1 datatable-tree-button"
  [loading]="row.treeStatus === TreeStatusEnum.LOADING"
  [opened]="row.treeStatus === TreeStatusEnum.EXPANDED"
  [disabled]="treeDisabled(row)"
  (onClick)="row.onTreeAction()"
/>
